import { getCityByPincode } from '../gql/common';

export const subcatIdMap = {
  // under 60
  cars: '71',
  'bikes-scooters': '72',
  'commercial-vehicles': '139',
  'spare-parts-accessories': '74',
  // under 269
  'mobile-phones': '149',
  tablets: '280',
  accessories: '212',
  wearables: '367',
  // under 246
  'pets-clinic': '254',
  'pet-foods': '252',
  'pet-care-accessories': '152',
  'pet-training': '253',
  'pet-shop': '639',
  // under 161
  brides: '162',
  grooms: '163',
  'wedding-planners': '224',
  // under 1
  announcements: '10',
  'charity-donate-ngo': '12',
  'car-pool': '110',
  'lost-found': '120',
  'tender-notice': '237',
  // under 281
  'event-management': '318',
  'live-events': '319',
  // under 194
  'career-counseling': '195',
  'certifications-training': '321',
  'competitive-exams-coaching': '317',
  'distance-learning-courses': '198',
  'entrance-exam-coaching': '316',
  'hobby-classes': '238',
  'play-schools-creche': '242',
  'schools-school-tuitions': '315',
  'study-abroad-consultants': '311',
  'text-books-study-material': '255',
  'vocational-skill-training': '320',
  workshops: '241',
  // under 179
  'acting-modeling-roles': '244',
  'acting-schools': '191',
  'actor-model-portfolios': '245',
  'art-directors-editors': '184',
  'fashion-designers-stylists': '187',
  'make-up-hair-films-tv': '188',
  'modeling-agencies': '182',
  musicians: '192',
  'other-entertainment': '193',
  'photographers-cameraman': '189',
  'script-writers': '183',
  'set-designers': '185',
  'sound-engineers': '186',
  'studios-locations-for-hire': '190',
  // under 40
  'home-office-furniture': '56',
  'home-decor-furnishings': '171',
  household: '54',
  kitchenware: '313',
  'antiques-handicrafts': '146',
  paintings: '206',
  'sport-fitness-equipment': '53',
  bicycle: '347',
  'books-magazines': '52',
  'musical-instruments': '148',
  'coins-stamps': '204',
  collectibles: '169',
  'music-movies': '55',
  'clothing-garments': '145',
  watches: '202',
  jewellery: '168',
  'bags-luggage': '207',
  footwear: '314',
  'fashion-accessories': '203',
  'health-beauty-products': '210',
  'gifts-stationary': '167',
  'toys-games': '57',
  'baby-infant-products': '170',
  kidslearning: '312',
  'wholesale-bulk': '209',
  'everything-else': '58',
  // under 247
  // Home Appliances
  'refrigerators-fridge': '369',
  'washing-machines': '371',
  'air-conditioners-ac': '111',
  'air-coolers': '111',
  'water-heaters-geysers': '111',
  'ceiling-fans': '111',
  'table-fans': '111',
  'vacuum-cleaners': '111',
  'sewing-machines': '111',
  iron: '111',
  'room-heaters': '111',
  'air-purifiers': '111',
  'home-others': '111',
  // Laptop & Accessories
  laptops: '147',
  'desktops-computers': '147',
  printers: '213',
  routers: '213',
  monitor: '213',
  cpu: '213',
  'external-hard-disks': '213',
  'data-cards': '213',
  ram: '213',
  'usb-drives': '213',
  'graphics-card': '213',
  motherboard: '213',
  keyboards: '213',
  mouses: '213',
  'adapters-power-cables': '213',
  'access-points': '213',
  speakers: '213',
  switches: '213',
  batteries: '213',
  'printer-ink-and-toners': '213',
  'external-dvd-writers': '213',
  'wireless-usb-adapters': '213',
  scanners: '213',
  webcams: '213',
  'network-cards': '213',
  'blank-media': '213',
  'cooling-pads': '213',
  'ethernet-cables': '213',
  headsets: '213',
  headphones: '213',
  // Kitchen Appliances
  'home-kitchen-appliances': '111',
  'water-purifiers': '111',
  'microwave-ovens': '111',
  'mixer-grinder-juicer': '111',
  'induction-cook-tops': '111',
  'dish-washers': '111',
  'oven-toaster-griller': '111',
  'food-processors': '111',
  'electric-cookers': '111',
  'coffee-makers': '111',
  'sandwich-makers': '111',
  'gas-stove': '111',
  'electric-kettles': '111',
  'pop-up-toasters': '111',
  'hand-blenders': '111',
  'air-fryer': '111',
  'electric-tandoor': '111',
  'roti-makers': '111',
  'water-dispenser': '111',
  // Audio Video and Gaming
  tv: '51',
  'music-systems-home-theatre': '223',
  'video-games-consoles': '205',
  'ipods-mp3-players': '150',
  'dvd-players': '51',
  'set-top-box': '51',
  'digital-slr': '112',
  'digital-point-shoot-cameras': '112',
  'cameras-digicams': '112',
  'camera-accessories': '201',
  'binoculars-telescopes': '112',
  camcorders: '112',
  'film-cameras': '112',
  'inverters-ups-generators': '248',
  'tools-machinery-industrial': '113',
  // 'everything-else': '58',
  'fax-epabx-office-equipment': '122',
  'security-equipment-products': '211',
  'office-supplies': '214',
  //
  'mobiles-tablets': '269',
  'electronics-appliances': '247',
  'home-lifestyle': '40'
};

export const redirect404 = {
  'clothing-garments': '145',
  watches: '202',
  'bags-luggage': '207',
  footwear: '314',
  'fashion-accessories': '203'
};

export const titleName = {
  cars: 'Cars',
  'bikes-scooters': 'Bikes & Scooters',
  'commercial-vehicles': 'Commercial Vehicles',
  'spare-parts-accessories': 'Accessories'
};

export const RESUME_AD_KEY = 'POST_AD_DATA';

export const papCategories =
  // eslint-disable-next-line
  'cars-bikes|electronics-appliances|mobiles-tablets|pets|matrimonial|community|events|education|entertainment|home-lifestyle|realestate';

export const PAPCategoriesForGAEvents = {
  'cars-bikes': 'CarsBikes',
  'electronics-appliances': 'ElectronicsAppliances',
  'mobiles-tablets': 'MobilesTablets',
  pets: 'PetsPetsCare',
  matrimonial: 'Matrimonial',
  community: 'Community',
  events: 'Events',
  education: 'Education',
  entertainment: 'Entertainment',
  'home-lifestyle': 'HomeLifestyle',
  realestate: 'RealEstate',
  jobs: 'Jobs'
};

const commonAttributes = ['brand_name', 'model_name', 'price', 'condition', 'product_type'];

const escrowAttr = [
  'zipcode',
  'is_c2c_enabled',
  'physical_condition',
  'is_mandatory_price_enabled',
  'purchase_year',
  'seller_convenience_fee',
  'invoice',
  'physical_checks',
  'accessory_type',
  'no_negotiate_price',
  'age',
  'c2c_pickup',
  'wearable_type',
  'furniture_material',
  'furniture_type',
  'quantity',
  'furniture_sub_type',
  'furniture_age',
  'furnishing_type',
  'equipment_type',
  'cycle_type',
  'genre',
  'instrument_type',
  'media_type',
  'clothing_for',
  'clothing_style',
  'size',
  'watch_type',
  'watch_for',
  'jewellery_type',
  'age_group',
  'features',
  'door_style',
  'defrosting_type',
  'capacity',
  'shoe_size',
  'energy_rating',
  'pattern',
  'loading',
  'operation',
  'appliance_type',
  'cooler_capacity',
  'wattage',
  'ac_type',
  'tonnage',
  'heater_type',
  'screen_size',
  'Screen_size',
  'ram',
  'also_includes',
  'also_include',
  'peripheral_type',
  'heater_capacity',
  'oven_type',
  'tv_resolution',
  'tv_feature',
  'display',
  'hdmi',
  'speaker_type',
  'cam_resolution',
  'battery_type',
  'sensor_type',
  'optical_zoom',
  'access_details'
];

const coreAttr = [
  'course_fees',
  'pet_type',
  'education_stream',
  'counselling_fees',
  'institute_name',
  'institute_address',
  'institute_website',
  'tution_fees',
  'course_category',
  'courses',
  'product_type',
  'course_domain',
  'delivery_mode',
  'course_duration',
  'monthly_fees',
  'country',
  'services_offered',
  'exam_training',
  'school_board',
  'subjects',
  'standard',
  'coaching_fees',
  'industry',
  'training_type',
  'features',
  'hobby',
  'classes_held_on',
  'class_timings',
  'eligbility',
  'program_type',
  'all_courses',
  'affiliated_university',
  'career_stream',
  'specialization',
  'age_group',
  'programs_offered',
  'education_method',
  'facilities',
  'student_teacher_ratio',
  'age',
  'height',
  'marital_status',
  'religion',
  'qualification',
  'current_occupation',
  'sun_sign',
  'nakshatra',
  'mother_tongue',
  'service_type',
  'occasion',
  'capacity',
  'event_category',
  'event_type',
  'event_start_date',
  'event_end_date',
  'event_start_time',
  'event_end_time',
  'project_type',
  'role_type',
  'looking_for',
  'shoot_date',
  'compensation',
  'professional_training',
  'dob',
  'experience',
  'experienced',
  'bust_size',
  'waist_size',
  'hip_size',
  'body_type',
  'gender',
  'languages',
  'price'
];
export const postAdElementsMap = {
  ad_details: [
    'ad_type',
    'title',
    'is_alert',
    'description',
    'is_user_privacy',
    'user_type',
    'city',
    'locality',
    'cat',
    'subcat',
    'images',
    'payment_type'
  ],
  cars_bikes: [
    ...commonAttributes,
    'vehicle_type',
    'variant',
    'registration_year',
    'kms_driven',
    'fuel_type',
    'ownership',
    'color',
    'isinsured',
    'insurance_validity'
  ],
  entertainment: [...coreAttr],
  education: [...coreAttr],
  pets: [...coreAttr],
  community: [...coreAttr],
  events: [...coreAttr],
  matrimonial: [...coreAttr],
  mobiles_tablets: [...commonAttributes, ...escrowAttr],
  home_lifestyle: [...commonAttributes, ...escrowAttr],
  electronics_appliances: [...commonAttributes, ...escrowAttr]
};

export const POSTAD_DATA_KEY = '__postAd';

export const ResumeStaticText = [
  'There is an ad you were trying to post earlier',
  'Would you like to continue posting it?'
];

export const AB_RAND_POSTAD_ANDROID_DOWNLOAD = 5;

export const AB_RAND_POSTAD_THRESHOLD = {
  'cars-bikes': 100,
  'mobiles-tablets': 100,
  'electronics-appliances': 100,
  pets: 100,
  matrimonial: 100,
  community: 100,
  events: 100,
  education: 100,
  entertainment: 100,
  'home-lifestyle': 100
};

export const AB_RAND_EDITAD_THRESHOLD = 5;

export const CAR_SUBCAT_MAPPING = {
  71: {
    catName: 'cars',
    title: 'sell-your-used-cars',
    catId: 1399
  },
  72: {
    catName: 'bikes-scooters',
    title: 'sell-your-used-bikes-scooters',
    catId: 1402
  },
  139: {
    catName: 'cars-bikes',
    title: 'sell-used-commercial-vehicles',
    catId: 1398
  },
  74: {
    catName: 'cars-bikes',
    title: 'sell-spare-parts-accessories',
    catId: 1404
  }
};

const ESCROW_SUBCAT_MAPPING = {
  149: {
    catId: 1388
  },
  212: {
    catId: 18222211237
  },
  367: {
    catId: 18332902
  },
  280: {
    catId: 18237461
  },
  56: {
    catId: 1380
  },
  171: {
    catId: 1383
  },
  54: {
    catId: 1384
  },
  313: {
    catId: 18277672
  },
  146: {
    catId: 1372
  },
  206: {
    catId: 18222211027
  },
  53: {
    catId: 1394
  },
  347: {
    catId: 18310882
  },
  52: {
    catId: 1376
  },
  148: {
    catId: 1390
  },
  204: {
    catId: 18222209945
  },
  169: {
    catId: 1377
  },
  55: {
    catId: 1389
  },
  145: {
    catId: 1373
  },
  202: {
    catId: 18222209387
  },
  168: {
    catId: 1386
  },
  207: {
    catId: 18222211062
  },
  314: {
    catId: 18278652
  },
  203: {
    catId: 18222209664
  },
  210: {
    catId: 18222211167
  },
  167: {
    catId: 1381
  },
  57: {
    catId: 1396
  },
  170: {
    catId: 1374
  },
  312: {
    catId: 18276692
  },
  209: {
    catId: 18222211132
  },
  // 58: {
  //   catId: 1387
  // },
  369: {
    catId: 18408347
  },
  371: {
    catId: 18410956
  },
  111: {
    catId: 1382
  },
  147: {
    catId: 1378
  },
  51: {
    catId: 1379
  },
  112: {
    catId: 1393
  },
  248: {
    catId: 18222212695
  },
  113: {
    catId: 1395
  },
  58: {
    catId: 18222213064
  },
  122: {
    catId: 1391
  },
  211: {
    catId: 18222211202
  },
  214: {
    catId: 18222211307
  }
};

export const getEscrowDetails = mGlobal => {
  return {
    ...ESCROW_SUBCAT_MAPPING[mGlobal],
    catName: 'Escrow',
    title: 'post-classifieds-ads'
  };
};

export const QueryEnabled = {
  zipcode: {
    child: 'city',
    resKey: 'getCityByPin',
    validation: value => value.length === 6,
    query: getCityByPincode
  }
};
